/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Phase2_Fix_Public_Tool_FailedInputs */

const en_phase2_fix_public_tool_failed = /** @type {(inputs: Phase2_Fix_Public_Tool_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AnyAPI could not complete this public request. Try again in a moment.`)
};

const zh_hans1_phase2_fix_public_tool_failed = /** @type {(inputs: Phase2_Fix_Public_Tool_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AnyAPI 无法完成这次公开请求，请稍后再试。`)
};

const pt_br2_phase2_fix_public_tool_failed = /** @type {(inputs: Phase2_Fix_Public_Tool_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A AnyAPI não conseguiu concluir esta requisição pública. Tente de novo em instantes.`)
};

const es_phase2_fix_public_tool_failed = /** @type {(inputs: Phase2_Fix_Public_Tool_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AnyAPI no pudo completar esta solicitud pública. Inténtalo de nuevo en un momento.`)
};

const fr_phase2_fix_public_tool_failed = /** @type {(inputs: Phase2_Fix_Public_Tool_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AnyAPI n’a pas pu terminer cette requête publique. Réessayez dans un instant.`)
};

const de_phase2_fix_public_tool_failed = /** @type {(inputs: Phase2_Fix_Public_Tool_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AnyAPI konnte diese öffentliche Anfrage nicht abschließen. Versuch es gleich noch einmal.`)
};

const ru_phase2_fix_public_tool_failed = /** @type {(inputs: Phase2_Fix_Public_Tool_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AnyAPI не смог выполнить этот публичный запрос. Повторите через минуту.`)
};

const it_phase2_fix_public_tool_failed = /** @type {(inputs: Phase2_Fix_Public_Tool_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AnyAPI non ha potuto completare questa richiesta pubblica. Riprova tra un attimo.`)
};

/**
* | output |
* | --- |
* | "AnyAPI could not complete this public request. Try again in a moment." |
*
* @param {Phase2_Fix_Public_Tool_FailedInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const phase2_fix_public_tool_failed = /** @type {((inputs?: Phase2_Fix_Public_Tool_FailedInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Phase2_Fix_Public_Tool_FailedInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_phase2_fix_public_tool_failed(inputs)
	if (locale === "pt-BR") return pt_br2_phase2_fix_public_tool_failed(inputs)
	if (locale === "es") return es_phase2_fix_public_tool_failed(inputs)
	if (locale === "fr") return fr_phase2_fix_public_tool_failed(inputs)
	if (locale === "de") return de_phase2_fix_public_tool_failed(inputs)
	if (locale === "ru") return ru_phase2_fix_public_tool_failed(inputs)
	if (locale === "it") return it_phase2_fix_public_tool_failed(inputs)
	return en_phase2_fix_public_tool_failed(inputs)
});